export const locales = [
    {
        locale: 'Italiano',
        localeId: 'it-IT'
    },
    {
        locale: 'English',
        localeId: 'en-US'
    }
];
